export enum Prices{
    TOP_BREAD = 75,
    BOTTOM_BREAD = 65,
    SALAD = 30,
    BACON = 35,
    CHEESE = 45,
    MEAT = 80,
    EXTRA = 20
}